import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-clear",
  "use": "format-clear-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-clear\"><path fill-rule=\"evenodd\" d=\"m2 6.27 6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5 2 6.27Zm4-1.09L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6v.18Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol